import * as React from 'react';
export default (function (props) {
  return React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.children);
});


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/table/FilterDropdownMenuWrapper.js
// module id = 808
// module chunks = 0